module.exports = __webpack_public_path__ + "img/logo-2.d40c5134.png";